import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useCheckPromoCode = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.IUsePromoCodeRequestData): Promise<Types.IUsePromoCodeResponseData> => {
        const { data } = await send<Types.IUsePromoCodeRequestData, Types.IUsePromoCodeResponseData>({
            ID: 35890,
            description: 'Use Promo Code',
            responses: [35891, 35892],
            context: 'PROMO',
            ...request
        });

        return data;
    }, [send]);
};
